import Modal from "../../../../../components/modalWindow/modal";
import { ObjectState, ProcessMarker } from "../../types/tasklListViewProps";
import { AdminDecisionModalProps } from "./types/adminDecisionModalProps";
import { ReactComponent as AdminDecision } from '../../../../../icons/assignment_late.svg';
import { ReactComponent as AccountCircle } from '../../../../../icons/account_circle.svg';
import { ReactComponent as UploadGeom } from '../../../../../icons/polyline.svg';
import { ReactComponent as CancelTask } from '../../../../../icons/cancel.svg';
import ButtonField from "../../../../../components/buttonField/buttonField";
import { ButtonFieldProps } from "../../../../../components/buttonField/types/buttonFieldProps";
import { classNameBtn, iconPosition } from "../../../../../components/shared/button/types/buttonProps";
import { stylizationVerticalAlign } from "../../../../../components/shared/stylization";
import { useContext, useEffect, useState } from "react";
import PermissionsContext from "../../../../../contexts/permissionsContext";
import ViewContext from "../../../../../contexts/viewContext";
import { getAnalysisErrorDetails } from "../../../../../services/processService/processService";
import { apiContext } from "../../../../../contexts/apiContext";
import Spinner from "../../../../../components/spinner/spinner";
import { ClassNameSpinner } from "../../../../../components/spinner/types/spinnerProps";
import { notifyError } from "../../../../../components/snackbar/snackbar";

const AdminDecisionModal = (props: AdminDecisionModalProps) => {
    const api = useContext(apiContext);
    const { functionsPermissions } = useContext(PermissionsContext);
    const { setViewType, viewTypes, setViewData } = useContext(ViewContext);
    const [loading, setLoading] = useState<boolean>(false);
    const [failedStep, setFailedStep] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<string>("");

    // Query waiting room for error details
    useEffect(() => {
        setLoading(true);
        getAnalysisErrorDetails(api.apiUrl + api.apiVersion, props.waitingRoomRec.GLOBALID).then((res: any) => {
            setFailedStep(res.failedStep)
            setErrorMessage(res.errorMessage ? res.errorMessage : "Brak szczegółów błędu.")
            setLoading(false);
        })
        .catch(() => {
            notifyError({ message: "Próba pobrania podsumowania analiz zakończona niepowodzeniem" });
            props.onClose();
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Modal title
    const getAdminDecisionModalTitle = () => {
        var title = "";

        if (props.waitingRoomRec.STAN_OBIEKTU_DOM === ObjectState.AnalysisError) title = "Błąd krytyczny analiz";
        else if (props.waitingRoomRec.STAN_OBIEKTU_DOM === ObjectState.AnalysisDecision) title = "Błąd analiz";

        return title;
    }

    // Buttons
    const getBtnProps = (title: string, icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>, 
        onClick: React.MouseEventHandler<HTMLButtonElement>, disabled: boolean): ButtonFieldProps => {
        let className = classNameBtn.BigSecondary + " body-txt-XL modalBodyAdminDecisionBtns";

        return {
            BtnProps: {
                onClick: onClick,
                style: {
                    width: '99%',
                    height: '65px'
                },
                className: className,
                disabled: disabled
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: icon,
            iconPosition: iconPosition.Start,
        };
    }

    // Assign editor
    const handleAssignEditorClick = () => {
        if (props.handleAssigneEditorClick) props.handleAssigneEditorClick({ attributes: props.waitingRoomRec });
        props.onClose();
    }

    // Upload geometry 
    const handleUploadGeomClick = () => {
        setViewData({ isTriggeredByAdminDecision: true });
        setViewType(viewTypes.Home);
    }

    // Cancel task
    const isProcessOK = [ProcessMarker.O, ProcessMarker.K].includes(props.waitingRoomRec.ZNACZNIK_PROCESU_DOM);

    const handleCancelTaskClick = () => {
        props.onClose();
        if (props.setAdminDecisionRow) props.setAdminDecisionRow({ original: { attributes: props.waitingRoomRec } });
    }

    const getCancelBtnTitle = () => {
        return isProcessOK ? "Anuluj zadanie edycji (o, k)" : "Anuluj zadanie (a, n)";
    }

    const isCancelBtnDisabled = () => {
        return isProcessOK ? !functionsPermissions.cancelEditTaskProcessOAndK.active : !functionsPermissions.cancelProcessAAndN.active;
    }

    return (
        <Modal
            title={getAdminDecisionModalTitle()}
            titleIcon={AdminDecision}
            iconClass='titleIcon'
            width="35vw"
            height="70vh"
            onClose={props.onClose}
            bodyClassName="modalBodyAdminDecision"
        >
            {loading ? <Spinner spinnerClass={ClassNameSpinner.Big} /> :
                <>
                    <div>
                        <p style={{fontWeight: "bold"}}>Szczegóły błędu</p>
                        <p style={{color: "red", overflowWrap: "break-word", paddingRight: "5px"}}><span style={{fontWeight: "bold"}}>{failedStep ? `${failedStep}: ` : ''}</span>{errorMessage}</p>  
                    </div>           
                    <br />
                    <div>
                        <p style={{fontWeight: "bold"}}>Dostępne kroki</p>
                        <div style={{display: "flex", flexDirection: "column", gap: "10px", marginBottom: "5px"}}>
                            {props.waitingRoomRec.STAN_OBIEKTU_DOM === ObjectState.AnalysisDecision && 
                                <ButtonField {...getBtnProps("Akceptuj wyniki analizy - przypisz Edytora", AccountCircle, handleAssignEditorClick, !functionsPermissions.assignEditor.active)} />}
                            <ButtonField {...getBtnProps("Wgraj poprawioną geometrię", UploadGeom, handleUploadGeomClick, !functionsPermissions.processA.active)} />
                            <ButtonField {...getBtnProps(getCancelBtnTitle(), CancelTask, handleCancelTaskClick, isCancelBtnDisabled())} />
                        </div>
                    </div>
                </>
            }
        </Modal>
    )  
}

export default AdminDecisionModal;